import angular from 'angular';

angular.module('AaApp.Opp').constant('creditPrescreenStatuses', {
    processing: 0,
    error: 1,
    noDataReceived: 2,
    creditDataReceived: 3,
    financialDataReceived: 4
});
